<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white"> Please Wait...</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Artists

        <button mat-raised-button color="primary" style="font-size: 14px;
                    margin-right: 15px;" (click)="AddArtist()"><mat-icon>add</mat-icon>Add</button>
    </div>
</div>

<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Position Column -->
            <ng-container matColumnDef="a_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID. </th>
                <td mat-cell *matCellDef="let element"> {{element.a_id}} </td>
            </ng-container>

            <ng-container matColumnDef="image_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Image </th>
                <td mat-cell *matCellDef="let element"><img
                        src="https://aieventzo.com/upload/{{event_id}}/artist/{{element.image_name}}"
                        onerror="this.onerror=null; this.src='https://aieventzo.com/upload/default.png';"
                        style="width: 50px;height: 50px;padding: 2px 0px;border-radius: 10px;">
                </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="artist">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Artist </th>
                <td mat-cell *matCellDef="let element"> {{element.artist}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
                <td mat-cell *matCellDef="let element"> {{element.role}} </td>
            </ng-container>

            <ng-container matColumnDef="action" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button color="primary" matTooltip="Edit" style="margin-left: 5px;"
                        (click)="EditArtist(element.a_id)">
                        <mat-icon class=" m-0">edit</mat-icon>
                    </button>

                    <button mat-raised-button color="warn" matTooltip="Delete" style="margin-left: 5px;"
                        (click)="DeleteAdmin(element.a_id)">
                        <mat-icon class=" m-0">delete</mat-icon>
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
</div>